const File = ({ color, type }) => {
  const solid = (
    <svg
      width="16"
      height="21"
      viewBox="0 0 16 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14 20.5C14.5304 20.5 15.0391 20.2893 15.4142 19.9142C15.7893 19.5391 16 19.0304 16 18.5V6.5L10 0.5H2C1.46957 0.5 0.960859 0.710714 0.585786 1.08579C0.210714 1.46086 0 1.96957 0 2.5V18.5C0 19.0304 0.210714 19.5391 0.585786 19.9142C0.960859 20.2893 1.46957 20.5 2 20.5H14ZM9 2.5L14 7.5H9V2.5ZM3 6.5H6V8.5H3V6.5ZM3 10.5H13V12.5H3V10.5ZM3 14.5H13V16.5H3V14.5Z"
        fill={color}
      />
    </svg>
  );

  const regular = (
    <svg
      width="33"
      height="32"
      viewBox="0 0 33 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M26.8707 11.4481C26.8075 11.3034 26.719 11.1711 26.6094 11.0574L18.6094 3.05741C18.4957 2.94779 18.3635 2.8593 18.2187 2.79608C18.1787 2.77741 18.1361 2.76675 18.0934 2.75208C17.9819 2.71412 17.8657 2.69125 17.7481 2.68408C17.7201 2.68141 17.6947 2.66675 17.6667 2.66675H8.33341C6.86275 2.66675 5.66675 3.86275 5.66675 5.33341V26.6667C5.66675 28.1374 6.86275 29.3334 8.33341 29.3334H24.3334C25.8041 29.3334 27.0001 28.1374 27.0001 26.6667V12.0001C27.0001 11.9721 26.9854 11.9467 26.9827 11.9174C26.9762 11.7997 26.9533 11.6835 26.9147 11.5721C26.9014 11.5294 26.8894 11.4881 26.8707 11.4481ZM22.4481 10.6667H19.0001V7.21875L22.4481 10.6667ZM8.33341 26.6667V5.33341H16.3334V12.0001C16.3334 12.3537 16.4739 12.6928 16.7239 12.9429C16.974 13.1929 17.3131 13.3334 17.6667 13.3334H24.3334L24.3361 26.6667H8.33341Z"
        fill={color}
      />
      <path
        d="M11.0002 16.0001H21.6669V18.6667H11.0002V16.0001ZM11.0002 21.3334H21.6669V24.0001H11.0002V21.3334ZM11.0002 10.6667H13.6669V13.3334H11.0002V10.6667Z"
        fill={color}
      />
    </svg>
  );

  const getSVGByType = (type) => {
    switch (type) {
      case "solid":
        return solid;
      case "regular":
      default:
        return regular;
    }
  };

  return getSVGByType(type);
};

export default File;
